import {
  IOption,
  NavItem,
  SetupListInfoResponse,
  SetupListNavInfoByDepartment,
  UserPermission,
} from "../../../../types";
import { getDepartmentOption } from "./getDepartmentOption";
import { getSetupPermissions } from "./getSetupPermissions";

interface GetSetupListNavInfoParams {
  setupListInfo: SetupListInfoResponse[];
  favoritesList: string[];
  departments: IOption[];
  permissionsList: UserPermission[];
  enableRbacSetupManagement: boolean;
  isDevUser: boolean;
}

interface GetSetupListNavInfoResult {
  setupListNavInfoByDepartment: SetupListNavInfoByDepartment;
  favoritesSetupInfoList: NavItem[];
}

export const getSetupListNavInfoByDepartment = ({
  setupListInfo,
  favoritesList,
  departments,
  permissionsList,
  enableRbacSetupManagement,
  isDevUser,
}: GetSetupListNavInfoParams): GetSetupListNavInfoResult => {
  const setupListNavInfoByDepartment: SetupListNavInfoByDepartment = {};
  const favoritesSetupInfoList: NavItem[] = [];

  const permissionKeys = new Set(
    permissionsList.map(({ permission }) => permission),
  );

  setupListInfo.forEach(({ department, setups, departmentIds }) => {
    const departmentOption = getDepartmentOption({
      departmentValue: department,
      departmentOptions: departments,
    });

    if (!setupListNavInfoByDepartment[department]) {
      setupListNavInfoByDepartment[department] = {
        setups: [],
        departmentIds: [],
      };
    }

    const navItems: NavItem[] = Array.from(
      new Map(
        setups
          .map(({ code, name, description }) => {
            const setupItem: NavItem = {
              id: code,
              text: name,
              department: departmentOption,
              description,
              permissions: getSetupPermissions({
                code,
                permissionKeys,
                enableRbacSetupManagement,
                isDevUser,
              }),
            };

            if (
              favoritesList.includes(code) &&
              setupItem.permissions?.hasView
            ) {
              favoritesSetupInfoList.push(setupItem);
            }

            return [setupItem.id, setupItem] as const;
          })
          .filter(([, setupItem]) => setupItem.permissions?.hasView),
      ).values(),
    ).sort((a, b) => a.text.localeCompare(b.text));

    setupListNavInfoByDepartment[department].setups.push(...navItems);
    setupListNavInfoByDepartment[department].departmentIds.push(
      ...departmentIds,
    );
  });

  return {
    setupListNavInfoByDepartment,
    favoritesSetupInfoList,
  };
};
